/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import jQuery from "jquery";
import $ from "jquery";
import "bootstrap";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/mode/css/css";
import "codemirror/mode/python/python";
import "codemirror/mode/clike/clike";
import "codemirror/mode/php/php";
import "codemirror/mode/sql/sql";

import hljs from "highlight.js";
import "highlight.js/styles/github-dark.css";
import java from "highlight.js/lib/languages/java";
import python from "highlight.js/lib/languages/python";

import { doc, setDoc, Timestamp } from "firebase/firestore";
import { fireDB } from "../../../Backend/Firebase/FirebaseConfigData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Assign jQuery globally
declare global {
  interface Window {
    $: any;
    jQuery: any;
    hljs: any;
  }
}

if (typeof window !== "undefined") {
  window.$ = window.jQuery = jQuery;
  hljs.registerLanguage("java", java);
  hljs.registerLanguage("python", python);
  window.hljs = hljs;
}

interface ChapterData {
  chapterSlug: string;
  contentTitle: string;
  title: string;
  subheading: string;
  author: string;
  content: string;
  seoTitle: string;
  seoDescription: string;
  seoTags: string;
  seoHeading: string;
  canonicalUrl: string;
  chapterSlugManual?: boolean;
  titleManual?: boolean;
  seoHeadingManual?: boolean;
}

export default function Createnew() {
  const { id: bookSlug } = useParams<{ id: string }>();
  const [chapterData, setChapterData] = useState<ChapterData>({
    chapterSlug: "",
    contentTitle: "",
    title: "",
    subheading: "",
    author: "",
    content: "",
    seoTitle: "",
    seoDescription: "",
    seoTags: "",
    seoHeading: "",
    canonicalUrl: "",
  });

  const editorInitializedRef = useRef(false);
  const formatDropdownUidRef = useRef<string | null>(null);

  // Auto-generate slug, title, SEO heading, canonical URL
  useEffect(() => {
    if (chapterData.contentTitle) {
      const slugified = chapterData.contentTitle
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "_")
        .replace(/[^\w_]/g, "");

      setChapterData((prev) => ({
        ...prev,
        chapterSlug: prev.chapterSlugManual ? prev.chapterSlug : slugified,
        title: prev.titleManual ? prev.title : prev.contentTitle,
        seoHeading: prev.seoHeadingManual ? prev.seoHeading : prev.contentTitle,
        canonicalUrl: `https://greatmastersai.com/${bookSlug}/${prev.chapterSlugManual ? prev.chapterSlug : slugified}`,
      }));
    }
  }, [chapterData.contentTitle, bookSlug]);

  // Insert Code Block
  const insertCodeBlock = () => {
    const codeBlock = `
      <div class="code-wrapper mt-4">
        <div class="relative bg-gray-100 border rounded-lg p-4 font-mono overflow-auto">
          <button type="button" class="copy-btn absolute top-2 right-2 bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors">
            📋 Copy
          </button>
          <pre><code class="language-javascript">console.log("Hello, world!");</code></pre>
        </div>
      </div>
    `;
    $("#summernote").summernote("pasteHTML", codeBlock);
  };

  // Format Text dropdown button
  const formatTextDropdown = () => {
    const uid = "ftd_" + Math.random().toString(36).slice(2, 9);
    formatDropdownUidRef.current = uid;

    const dropdown = $(`
      <div class="format-text-dropdown" style="display:inline-block; position:relative;">
        <button type="button" class="note-btn btn btn-sm btn-light" aria-label="Format Text">
          Style ▾
        </button>
        <div class="ftd-menu hidden" style="
          position:absolute;
          top:100%;
          left:0;
          min-width:10rem;
          background:#ffffff;
          border:1px solid rgba(0,0,0,0.08);
          border-radius:6px;
          box-shadow:0 6px 18px rgba(0,0,0,0.08);
          z-index:9999;
          overflow:hidden;
        ">
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="p">Paragraph</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h1">Heading 1</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h2">Heading 2</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h3">Heading 3</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h4">Heading 4</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h5">Heading 5</a>
          <a href="#" class="block px-4 py-2 ftd-item" data-tag="h6">Heading 6</a>
        </div>
      </div>
    `);

    dropdown.find("button").on("click", (e) => {
      e.stopPropagation();
      dropdown.find(".ftd-menu").toggleClass("hidden");
    });

    dropdown.find(".ftd-item").on("click", function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const tag = $(this).data("tag") as string;
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (!range.collapsed) {
          const wrapper = document.createElement(tag);
          try {
            wrapper.appendChild(range.extractContents());
            range.insertNode(wrapper);
          } catch {
            document.execCommand("formatBlock", false, tag);
          }
        } else {
          const el = document.createElement(tag);
          el.innerHTML = "<br>";
          range.insertNode(el);
          const newRange = document.createRange();
          newRange.setStart(el, 0);
          newRange.collapse(true);
          selection.removeAllRanges();
          selection.addRange(newRange);
        }
      }
      dropdown.find(".ftd-menu").addClass("hidden");
    });

    $(document).on(`click.${uid}`, (e: any) => {
      if (!dropdown[0].contains(e.target)) {
        dropdown.find(".ftd-menu").addClass("hidden");
      }
    });

    return dropdown;
  };

  // Initialize Summernote editor
  const initializeSummernote = () => {
    if (typeof window !== "undefined" && $("#summernote").length > 0 && !editorInitializedRef.current) {
      editorInitializedRef.current = true;

      ($("#summernote") as any).summernote({
        height: window.innerHeight * 0.6,
        placeholder: "Write your chapter content here...",
        focus: true,
        resize: true,
        toolbar: [
          ["style", ["bold", "italic", "underline", "clear"]],
          ["font", ["strikethrough", "superscript", "subscript"]],
          ["fontsize", ["fontsize"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["insert", ["link", "picture", "video"]],
          ["custom", ["insertCode", "formatText"]],
          ["view", ["fullscreen", "codeview", "help"]],
        ],
        buttons: {
          insertCode: function () {
            return $(
              '<button type="button" class="btn btn-light m-3 btn-sm flex items-center gap-1 px-3 py-1 bg-green-400 border rounded-md shadow-sm hover:bg-red-800 hover:shadow-md transition-all">'
            )
              .html('<span class="font-mono text-sm">&lt;/&gt;</span> Insert Code')
              .on("click", insertCodeBlock);
          },
          formatText: formatTextDropdown,
        },
        callbacks: {
          onChange: function (contents: string) {
            setChapterData((prev) => ({ ...prev, content: contents }));
          },
        },
      });

      $("#summernote").summernote("code", chapterData.content);
    }
  };

  useEffect(() => {
    initializeSummernote();

    const handleCopyClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target && target.classList.contains("copy-btn")) {
        event.preventDefault();
        const wrapper = target.closest(".code-wrapper");
        const code = wrapper?.querySelector("code");
        if (code) {
          navigator.clipboard.writeText(code.innerText.trim()).then(() => {
            target.textContent = "✅ Copied!";
            setTimeout(() => (target.textContent = "📋 Copy"), 2000);
          });
        }
      }
    };

    document.addEventListener("click", handleCopyClick);

    return () => {
      document.removeEventListener("click", handleCopyClick);
      if (formatDropdownUidRef.current) {
        $(document).off(`click.${formatDropdownUidRef.current}`);
        formatDropdownUidRef.current = null;
      }
    };
  }, []);

  // Submit handler with TypeScript trim fix
  const handleSubmit = async () => {
    if (!bookSlug) {
      toast.error("Book slug is missing from the URL!");
      return;
    }

    const requiredFields: (keyof ChapterData)[] = ["chapterSlug", "contentTitle", "title", "author"];
    const emptyFields = requiredFields.filter(
      (field) =>
        !chapterData[field] ||
        (typeof chapterData[field] === "string" && !chapterData[field]?.trim())
    );

    if (emptyFields.length > 0) {
      toast.error("Please fill all required fields!");
      return;
    }

    try {
      await setDoc(
        doc(fireDB, "NewBlogs", bookSlug, "chapter", chapterData.chapterSlug),
        { ...chapterData, time: Timestamp.now() }
      );
      toast.success("✅ Chapter created successfully!");

      setChapterData({
        chapterSlug: "",
        contentTitle: "",
        title: "",
        subheading: "",
        author: "",
        content: "",
        seoTitle: "",
        seoDescription: "",
        seoTags: "",
        seoHeading: "",
        canonicalUrl: "",
      });

      ($("#summernote") as any).summernote("reset");
      editorInitializedRef.current = false;
      initializeSummernote();
    } catch (err) {
      console.error(err);
      toast.error("❌ Error creating chapter");
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-6">
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-xl shadow-lg space-y-6">
        <h1 className="text-3xl font-bold mb-4">
          Create New Chapter for "{bookSlug?.replace("_", " ")}"
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block font-medium mb-1">Chapter Slug</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.chapterSlug}
              onChange={(e) =>
                setChapterData({ ...chapterData, chapterSlug: e.target.value, chapterSlugManual: true })
              }
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Suggestion Title</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.title}
              onChange={(e) =>
                setChapterData({ ...chapterData, title: e.target.value, titleManual: true })
              }
            />
          </div>

          <div className="md:col-span-2">
            <label className="block font-medium mb-1">Blog Heading</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.contentTitle}
              onChange={(e) => setChapterData({ ...chapterData, contentTitle: e.target.value })}
            />
          </div>

          <div className="md:col-span-2">
            <label className="block font-medium mb-1">Author</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.author}
              onChange={(e) => setChapterData({ ...chapterData, author: e.target.value })}
            />
          </div>
        </div>

        <div>
          <label className="block font-medium mb-2">Content</label>
          <textarea id="summernote"></textarea>
        </div>

        <div className="space-y-3">
          <h2 className="text-2xl font-semibold">SEO Settings</h2>
          <div>
            <label className="block font-medium mb-1">SEO Meta Title</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.seoTitle}
              onChange={(e) => setChapterData({ ...chapterData, seoTitle: e.target.value })}
            />
          </div>
          <div>
            <label className="block font-medium mb-1">SEO Meta Description</label>
            <textarea
              className="w-full border p-3 rounded"
              value={chapterData.seoDescription}
              onChange={(e) => setChapterData({ ...chapterData, seoDescription: e.target.value })}
            />
          </div>
          <div>
            <label className="block font-medium mb-1">SEO Tags (comma separated)</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.seoTags}
              onChange={(e) => setChapterData({ ...chapterData, seoTags: e.target.value })}
            />
          </div>
          <div>
            <label className="block font-medium mb-1">SEO H1 Heading</label>
            <input
              className="w-full border p-3 rounded"
              value={chapterData.seoHeading}
              onChange={(e) =>
                setChapterData({ ...chapterData, seoHeading: e.target.value, seoHeadingManual: true })
              }
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Canonical URL</label>
            <input className="w-full border p-3 rounded bg-gray-100" value={chapterData.canonicalUrl} readOnly />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full mt-4 bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 font-semibold"
        >
          ✅ Create Chapter
        </button>
      </div>
      <ToastContainer />
    </div>
  );
}
